import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCb({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M2.5 3.5h19a.5.5 0 01.5.5v16a.5.5 0 01-.5.5h-19A.5.5 0 012 20V4a.5.5 0 01.5-.5z"
        fill="url(#CB_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.662 11.773v.317h4.686v.005c0 1.05-.291 2.213-1.135 2.902-.847.69-2.247.909-3.539.909-1.33 0-2.71-.193-3.561-.92-.8-.684-1.113-1.87-1.113-2.891 0-.974.16-2.058.898-2.732.856-.782 2.39-1.079 3.776-1.079 1.332 0 2.824.27 3.675 1 .715.612.95 1.564.992 2.489H7.662zm4.993.317h6.509v-.002c.952.048 1.71.883 1.71 1.847 0 .963-.758 1.748-1.71 1.796v.005h-6.509V12.09zm8.1-1.989a1.68 1.68 0 01-1.538 1.671h-6.562v-3.34h6.23c.061-.007.14.005.204.005.929 0 1.665.736 1.665 1.664z"
        fill="#FEFEFE"
      />
      <defs>
        <linearGradient
          id="CB_svg__paint0_linear"
          x1={9.834}
          y1={-2.636}
          x2={-1.693}
          y2={16.15}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02245A" />
          <stop offset={0.309} stopColor="#016598" />
          <stop offset={0.638} stopColor="#018D9C" />
          <stop offset={1} stopColor="#13973E" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgCb
